import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { PermissionService } from '../common';

@Injectable({
  providedIn: 'root',
})
export class EoPermissionGuard implements CanActivate {
  constructor(
    private readonly permissionService: PermissionService,
    private readonly router: Router
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    const permissions = route.data['permissions'];
    const permissionLogic = route.data['permissionLogic'];

    if (permissions?.length === 0) return true;

    if (!this.permissionService.hasPermission(permissions, permissionLogic)) {
      this.router.navigate(['not-authorized']);
      return false;
    }

    return true;
  }
}
